import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c("b-row", [_c("b-col", [_c("p", [_vm._v(_vm._s(_vm.message))])])], 1),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-col"),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                VBtn,
                { on: { click: _vm.onCancel } },
                [
                  _c(VIcon, { staticClass: "md-16" }, [
                    _vm._v("icon-remove"),
                  ]),
                  _vm._v(_vm._s(_vm.cancelButtonText)),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-2",
                  attrs: { color: "#13abff" },
                  on: { click: _vm.onSubmit },
                },
                [
                  _c(
                    "span",
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("icon-send"),
                      ]),
                      _vm._v(_vm._s(_vm.confirmButtonText)),
                    ],
                    1
                  ),
                  _vm.isLoading
                    ? _c("b-spinner", {
                        staticClass: "ml-1",
                        attrs: { small: "" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }